import styled from 'styled-components';
import { DrawerItem } from '@/components/Drawer/Drawer.styles';
import { ellipsisMultiline } from '@/styles/helpers';
import { Dropdown } from '@/components/UI/Dropdown';

export const SearchSuggestionsDropdown = styled(Dropdown).attrs({
  alignment: 'left',
  hasOverlay: false,
})`
  width: 100%;
`;

export const SearchSuggestionsContent = styled.div<{ $offsetLeft?: number }>`
  position: relative;
  top: -5px;
  left: ${({ $offsetLeft }) => -($offsetLeft ?? 15)}px;
  width: 100vw;

  @media (min-width: 950px) {
    top: 0;
    left: 0;
    width: 100%;
    border-radius: 14px;
    z-index: 11;
  }
`;

export const SearchSuggestionItem = styled(DrawerItem)`
  justify-content: space-between;
  padding: 15px;
  gap: 15px;

  @media (min-width: 950px) {
    border: 0;
    cursor: pointer;
    transition: background-color ease-in-out 0.2s;

    &:hover {
      background-color: ${({ theme }) => theme.palette.tertiary.background};
    }

    &:first-child {
      border-radius: 14px 14px 0 0;
    }

    &:last-child {
      border-radius: 0 0 14px 14px;
    }

    &:only-child {
      border-radius: 14px;
    }
  }
`;

export const SearchSuggestionText = styled.p`
  height: 18.5px;
  ${ellipsisMultiline(1)};
`;

export const SearchSuggestionCategoryItem = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 0;
`;

export const SearchSuggestionCategoryText = styled.p`
  ${ellipsisMultiline(1)};
  height: 17px;
  margin-top: 2px;
  font-size: 14px;
  color: ${({ theme }) => theme.palette.secondary.labels};
`;
